export const SUGGESTED_SELLING_CONTEXTS = {
  ADD_TO_CART_TIRE: 'ADD_TO_CART_TIRE',
  ADD_TO_CART_TIRE_ACCESSORY: 'ADD_TO_CART_TIRE_ACCESSORY',
  ADD_TO_CART_TPMS_ACCESSORY: 'ADD_TO_CART_TPMS_ACCESSORY',
  ADD_TO_CART_WHEEL: 'ADD_TO_CART_WHEEL',
  ADD_TO_CART_WHEEL_ACCESSORY: 'ADD_TO_CART_WHEEL_ACCESSORY',
  ADD_TO_CART_WINDSHIELD_WIPER_ACCESSORY: 'ADD_TO_CART_WIPER_ACCESSORY',
  ADD_TO_CART_WTP: 'ADD_TO_CART_WTP',
  CART_TOTAL_PAGE: 'CART_TOTAL_PAGE',
  HOMEPAGE: 'HOMEPAGE',
  PDP_TIRE: 'PDP_TIRE',
  PDP_TIRE_ACCESSORY: 'PDP_TIRE_ACCESSORY',
  PDP_TIRE_PDL: 'PDP_TIRE_PDL',
  PDP_TPMS_ACCESSORY: 'PDP_TPMS_ACCESSORY',
  PDP_WHEEL: 'PDP_WHEEL',
  PDP_WHEEL_ACCESSORY: 'PDP_WHEEL_ACCESSORY',
  PDP_WINDSHIELD_WIPER_ACCESSORY: 'PDP_WIPER_ACCESSORY'
};

export const DEFAULT_SUGGESTED_SELLING_VALUES = {
  browse: {
    isAccessory: false,
    isSet: false,
    isTire: false,
    isWheel: false,
    productSet: [],
    products: []
  },
  ignoreProducts: {
    accessories: [],
    set: [],
    tires: [],
    wheels: []
  },
  isAccessorySearched: false,
  isTireSearched: false,
  isWheelSearched: false
};
